import formatDateTime from '@orn/shared-web/utils/datetime/formatDateTime';
import * as React from 'react';

import Table from '../../../components/Table';
import { summaryFirstLine } from '../releaseLogic';

import ReleaseBodyMarkdown from './ReleaseBodyMarkdown';

import type { AdminListReleasesQuery } from '../__generated__/releaseOperations.gql';

interface IHistoryRowProps {
  release: AdminListReleasesQuery['adminListReleases'][number];
}

/**
 * One row in the release-history table. Collapsed by default to a
 * single-line summary; expand to show the full GitHub release body
 * rendered as markdown. Author column shows the MOPS audit-footer
 * email when present, otherwise the GitHub author login prefixed with
 * `@` to disambiguate the two formats.
 */
const HistoryRow = ({ release }: IHistoryRowProps) => {
  const [expanded, setExpanded] = React.useState(false);
  const summary = summaryFirstLine(release.body);
  const hasMore = release.body.length > summary.length;
  const authorLabel = release.mopsAuthorEmail ?? release.githubAuthorLogin ?? null;
  return (
    <Table.Row>
      <Table.Cell mono>{release.tag}</Table.Cell>
      <Table.Cell muted>{formatDateTime(release.createdAt)}</Table.Cell>
      <Table.Cell mono muted>
        {authorLabel
          ? // GitHub usernames are prefixed with `@` to disambiguate from the
            // operator-email format used for MOPS-authored releases.
            release.mopsAuthorEmail
            ? authorLabel
            : `@${authorLabel}`
          : '—'}
      </Table.Cell>
      <Table.Cell>
        {expanded ? (
          <ReleaseBodyMarkdown body={release.body} />
        ) : (
          <span className="text-fg-primary text-sm">{summary || <span className="text-fg-tertiary">—</span>}</span>
        )}
        {hasMore && (
          <button
            type="button"
            className="text-fg-brand-primary hover:text-fg-brand-primary_alt mt-1 text-xs underline underline-offset-2"
            onClick={() => setExpanded((v) => !v)}
          >
            {expanded ? 'Collapse' : 'Expand'}
          </button>
        )}
      </Table.Cell>
    </Table.Row>
  );
};

export default HistoryRow;
